import React, { useState, useEffect } from 'react';

interface Props {
    type: string,
    name: string,
    class?: string,
    autoFocus?: () => void,
    refCustom: React.RefObject<HTMLInputElement>,
    title: string,
    disabled?: boolean,
    readonly?: boolean
}


const InputComponent: React.FC<Props> = (props) => {
    const [, setValue] = useState('');

    const changeHandler = (event:React.FormEvent<HTMLInputElement>) => {
        setValue(event.currentTarget.value);
    };

    return (
        <input type={props.type}
               name={props.name}
               onChange={changeHandler}
               ref={props.refCustom}
               className={props.class}
               title={props.title}
               disabled={props.disabled}
               readOnly={props.readonly}
        />
    )
};

export { InputComponent }